var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "500.000000pt",
    height: "500.000000pt",
    viewBox: "0 0 500.000000 500.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,500.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4853 l0 -148 1102 -1102 1103 -1103 -1103 -1103 -1102 -1102 0 -148 0 -147 147 0 148 0 1102 1102 1103 1103 1103 -1103 1102 -1102 148 0 147 0 0 147 0 148 -1102 1102 -1103 1103 1103 1103 1102 1102 0 148 0 147 -147 0 -148 0 -1102 -1102 -1103 -1103 -1103 1103 -1102 1102 -148 0 -147 0 0 -147z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.4230334736e743b0142103fa2db543b3.svg";
export { ForwardRef as ReactComponent };